
/*
 * Date.parseRFC3339
 * extend Date with a method parsing ISO8601 / RFC 3339 date strings.
 * Usage: var d = Date.parseRFC3339( "2010-07-20T15:00:00Z" );
 */
Date.parseRFC3339 = function(dString){
  if (typeof dString != 'string') return;
  var result;
  var regexp = /(\d\d\d\d)(-)?(\d\d)(-)?(\d\d)(T)?(\d\d)(:)?(\d\d)?(:)?(\d\d)?([\.,]\d+)?($|Z|([+-])(\d\d)(:)?(\d\d)?)/i;
  var d = dString.match(new RegExp(regexp));
  if (d) {
    var year = parseInt(d[1],10);
    var mon = parseInt(d[3],10) - 1;
    var day = parseInt(d[5],10);
    var hour = parseInt(d[7],10);
    var mins = ( d[9] ? parseInt(d[9],10) : 0 );
    var secs = ( d[11] ? parseInt(d[11],10) : 0 );
    var millis = ( d[12] ? parseFloat(String(1.5).charAt(1) + d[12].slice(1)) * 1000 : 0 );
    if (d[13] && d[14]) {
      result = new Date(0);
      result.setUTCFullYear(year);
      result.setUTCMonth(mon);
      result.setUTCDate(day);
      result.setUTCHours(hour);
      result.setUTCMinutes(mins);
      result.setUTCSeconds(secs);
      result.setUTCMilliseconds(millis);
      if (d[13] && d[14]) {
        var offset = (d[15] * 60)
        if (d[17]) offset += parseInt(d[17],10);
        offset *= ((d[14] == '-') ? -1 : 1);
        result.setTime(result.getTime() - offset * 60 * 1000);
      }
    } else {
      result = new Date(year,mon,day,hour,mins,secs,millis);
    }
  }
  return result;
};

var SECONDS = 1000
var MINUTES = 60 * SECONDS
var HOURS = 60 * MINUTES
var DAYS = 24 * HOURS


window.linkify =  function linkify(inputText) {
  if (!inputText) return undefined;
    var replacedText, replacePattern1, replacePattern2, replacePattern3;

    //URLs starting with http://, https://, or ftp://
    replacePattern1 = /(\b(?:https?|ftp):\/\/([-A-Z0-9+&@#%?=~_|!:,.;]*)[-A-Z0-9+&@#%\/?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    replacedText = inputText.replace(replacePattern1, function(string, url, title) {
      var paperRE = /https:\/\/(paper)\.dropbox\.com\/doc\/(?:[^#"<]*-)?(\w+)/;

      if (url.match(paperRE)) {
        var newTitle = titleForPaperURL(url)
        if (newTitle.length) title = newTitle
      }
      return '<a href="' + url +'}" target="_blank">'+title+'</a>'
    });

    //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

    //Change email addresses to mailto:: links.
    replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

    return replacedText;
}

function titleForPaperURL(url) {
  var bits = url
    .split("/")
    .pop()
    .split("--")
    .shift()
    .split("-");
  // bits.pop();
  return bits.join(" ");
}



 function relativeDate(timestamp) {
  if (!timestamp) return undefined;
  var midnight = new Date();
  midnight.setHours(0,0,0,0); // last midnight
  var delta = Math.round((timestamp - midnight) / 1000);
  var minute = 60,
      hour = minute * 60,
      day = hour * 24,
      week = day * 7;

  if (delta < - (midnight.getDay()-1) * day) {
    return (-Math.round(delta / day)) + " days ago"
    return timestamp.toLocaleDateString(undefined, { month: 'long', day: 'numeric' });
  } else if (delta < -1 * day) {
    return timestamp.toLocaleDateString(undefined, { weekday: 'long' });
  } else if (delta < 0 * day) {
    return "Yesterday";
  } else if (delta < 1 * day) {
    return "Today"
  } else if (delta < 2 * day) {
    return "Tomorrow"
  } else if (delta < 1 * week) {
    return timestamp.toLocaleDateString(undefined, { weekday: 'short' });
  } else {

    return timestamp.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  }
}


location.clearAndReload = function() {
  if (document.body) {
    document.body.style.display = "none";
  }
  location.reload();
}


String.pad = function() {
  var string = this;
  if (("" + string).length < 2) string = "0" + string;
  return string;
}